import React from 'react';
import {createPortal} from 'react-dom';
import './preloader.scss';

const Preloader = () =>{
  return(
    createPortal(
      <div className="ecn-preloader-wrapper">
       <div className="loadingio-spinner-pulse-m6xhslg70k">
          <div className="ldio-53m4ly87z12">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>,
      document.body
    )
  );
}

export default Preloader;